import React from 'react'
import { useSelector } from 'react-redux'
import clsx from 'clsx'
import moment from 'moment'

import { EventCard } from '../EventCard'
import { SectionBlock } from '../SectionBlock'

import { useStyles } from './PastEventsSection.style'

const PastEventsSection = ({ altMode }) => {
  const classes = useStyles()

  const { championship } = useSelector((state) => state.championships)
  const { events } = championship

  const pastEvents = events
    .filter((x) => moment(x.to).isBefore(moment()))
    .sort(
      (a, b) =>
        moment(b.from).diff(moment(a.from)) ||
        a.name.toLowerCase().trim().localeCompare(b.name.toLowerCase().trim())
    )

  return (
    !!pastEvents.length && (
      <SectionBlock title='Eventos anteriores' className={clsx(altMode && classes.altSection)}>
        <div className={classes.eventsContainer}>
          {pastEvents.map((e) => (
            <EventCard key={e.id} event={e} previous altMode={altMode} />
          ))}
        </div>
      </SectionBlock>
    )
  )
}

export default PastEventsSection
